import moment from 'moment';
import { useMemo } from 'react';

export const useDefaultStartTime = () =>
  useMemo(() => moment().set({ hour: 9, minute: 0, seconds: 0 }).format(), []);
